
import Chart from "chart.js/auto";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, scales } from 'chart.js';
import { PolarArea } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

// got chart example here
// https://codesandbox.io/p/devbox/reactchartjs-react-chartjs-2-default-t64th?file=%2FApp.tsx%3A13%2C25

// export const NUMBER_CFG = {count: 5, min: 0, max: 100};

function MyChart({ chartData }) {
	const data = {
	labels: ['Ethnicity', 'Nationality', 'Gender', 'Sexuality', 'Age'],
	datasets: [
	  {
		label: 'Points Scored',
		data: chartData,
		backgroundColor: [
		  'rgba(67, 97, 238, 0.7)', 
		  'rgba(247, 37, 133, 0.7)',
		  'rgba(40, 153, 79, 0.7)',
		  'rgba(114, 9, 183, 0.7)',
		  'rgba(250, 179, 74, 0.7)',
		],
		borderColor: [
		  'rgba(67, 97, 238, 1)',
		  'rgba(247, 37, 133, 1)',
		  'rgba(40, 153, 79, 1)',
		  'rgba(114, 9, 183, 1)',
		  'rgba(250, 179, 74, 1)',
		],
		borderWidth: 1,
	  },
	],
  };
  
  const options = {
	// responsive: false,
	// maintainAspectRatio: false,
	scales: 
		{
			r: {
				min: 0, 
				max: 10,
				ticks: {
					stepSize: 1
				}
			}
		},
	plugins: {
	legend: {
		display: true,
		labels: {
			color: 'rgb(0, 0, 0)',
			font: {
				size: 16
			}
		}
	}
	}

  }
  return <PolarArea className="chart" data={data} options={options} />;
}

export default MyChart;